import { Action, createReducer, on } from '@ngrx/store';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

import {
  initialState,
  EntityDireccionesGeograficaIDEState,
  entityDireccionesGeograficaIDEAdapter
} from './entity-direcciones-geografica-ide.state';
import {
  entityDireccionesGeograficaIDELoadFailure,
  entityDireccionesGeograficaIDELoadRequest,
  entityDireccionesGeograficaIDELoadSuccess,
} from './entity-direcciones-geografica-ide.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityDireccionesGeograficaIDELoadRequest, (state, {q, mapa}) => ({
    ...state,
    mapa: mapa,
    isLoading: true,
    error: null 
  })),
  on(entityDireccionesGeograficaIDELoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error 
  })),
  on(entityDireccionesGeograficaIDELoadSuccess, (state, { items, mapa }) => {
    const nuevosResultadosPorMapa = {
      ...(state.resultadosPorMapa || {}),
      [mapa]: items
    };
    
    return {
      ...entityDireccionesGeograficaIDEAdapter.setAll(items, state),
      resultadosPorMapa: nuevosResultadosPorMapa,
      mapa: mapa,
      isLoading: false,
      error: null
    };
  }),
);

export function direccionesGeograficaIDEReducer(
  state: EntityDireccionesGeograficaIDEState | undefined,
  action: Action
) {
  return reducer(state, action);
}